import { Button, message } from "antd";
import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom/dist";
import usePostData from "../../../api/usePostData";
import AppInput from "../../../common/AppInput";
import AuthFooter from "../../../components/AuthFooter/AuthFooter";
import Heading from "../../../components/Heading/Heading";
import { forgetPasswordEmailValidation } from "../../../utils/validations";
import { RestPasswordTracking } from "../../../utils/mixpanel";

/**
 * A component that represents the email step, which is the first stepf, of the forget password process
 *
 * @returns {JSX.Element}
 */

export default function EmailConfirmationStep() {
  const { postData, errors } = usePostData();
  const navigate = useNavigate();
  const { t } = useTranslation("global");

  const initialValues = {
    email: "",
  };

  const onSubmit = async (values, { setSubmitting }) => {
    const data = {
      email: values.email,
    };
    const response = await postData({
      route: "api/method/airport_transport.api.user.reset_password",
      data,
    });
    // Redirect to OTP verification screen
    if (response?.status === 200) {
      navigate(`/forget-password?email=${values.email}`, {
        state: { otpStep: true, email: values.email },
      });
    } else {
      RestPasswordTracking(false, "Email does not exist");
    }
    setSubmitting(false);
  };

  useEffect(() => {
    if (errors?.error) {
      message.error(`${errors.error}`);
    }
  }, [errors]);

  return (
    <>
      <div className="sm:w-screen w-full position relative">
        <div className="position absolute left-0 top-0">
          <img
            src="./assets/signin/left_vector.png"
            alt="left_vector"
            className="w-24 h-24 md:w-48 md:h-48"
          />
        </div>
        <div className="position absolute right-0 bottom-0">
          <img
            src="./assets/signin/right_vector.png"
            alt="right_vector"
            className="w-24 md:w-48 h-18 md:h-36"
          />
        </div>

        <div className="z-20 sm:w-screen w-full min-h-screen flex flex-row justify-center items-center">
          <div className="flex flex-col justify-center items-center">
            <Link className="mb-4 cursor-pointer" to={"/"}>
              <img
                src="./assets/header/LogoSVG.svg"
                alt="Moshrouk Trips"
                className="w-16 h-13"
              />
            </Link>
            <div className="mt-4 block w-72 md:w-auto p-3 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
              <div className="w-auto md:w-96 text-center">
                <Heading
                  title={t("forget_text")}
                  className={"text-2xl text-[#0E0E11]"}
                />
              </div>

              <div>
                <div className="p-2 md:p-4">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={forgetPasswordEmailValidation}
                    onSubmit={onSubmit}
                  >
                    {({ errors, touched }) => (
                      <Form>
                        <div>
                          <AppInput
                            name="email"
                            type="email"
                            label={t("hero.enter_email_text")}
                            error={errors.email}
                            touched={touched.email}
                          />
                        </div>
                        <div className="text-center mt-6">
                          <Button
                            className="bg-background_steel_blue w-full text-text_white hover:bg-gray-100 font-medium rounded text-sm px-5 py-2.5 me-2 mb-2"
                            type="submit"
                            htmlType="submit"
                          >
                            {t("confirm_text")}
                          </Button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
            <div className="my-2">
              <AuthFooter />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
